module.exports = __webpack_public_path__ + "img/nain3.9669f5f2.png";